// config
import { appConfig } from '../../config/app-config';

export const userConfig = {

   debugMode: false,

   // URL
   urlUserLogin:           '/auth/login',
   urlDataBackendVersion:  '/api/info/buildVersion',              // get
   urlUserRoles:           '/api/v1/user/roles',
   urlPasswordChange: '/api/v1/user/password',
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/config/user.config.ts